/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PublicHolidayKind = {
    PublicHoliday: 'PublicHoliday',
    Dienstfrei: 'Dienstfrei'
} as const;
export type PublicHolidayKind = typeof PublicHolidayKind[keyof typeof PublicHolidayKind];


export function instanceOfPublicHolidayKind(value: any): boolean {
    for (const key in PublicHolidayKind) {
        if (Object.prototype.hasOwnProperty.call(PublicHolidayKind, key)) {
            if (PublicHolidayKind[key as keyof typeof PublicHolidayKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PublicHolidayKindFromJSON(json: any): PublicHolidayKind {
    return PublicHolidayKindFromJSONTyped(json, false);
}

export function PublicHolidayKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicHolidayKind {
    return json as PublicHolidayKind;
}

export function PublicHolidayKindToJSON(value?: PublicHolidayKind | null): any {
    return value as any;
}

export function PublicHolidayKindToJSONTyped(value: any, ignoreDiscriminator: boolean): PublicHolidayKind {
    return value as PublicHolidayKind;
}

